import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import { MobileBottomNav } from "@/components/MobileBottomNav";
import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import PaymentPage from "@/pages/PaymentPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import DashboardPage from "@/pages/DashboardPage";
import LayerDetailPage from "@/pages/LayerDetailPage";
import JournalPage from "@/pages/JournalPage";
import SelfTestsPage from "@/pages/SelfTestsPage";
import ExercisesPage from "@/pages/ExercisesPage";
import DiaryPage from "@/pages/DiaryPage";
import QuotesPage from "@/pages/QuotesPage";
import ProgressMapPage from "@/pages/ProgressMapPage";
import CompletionPage from "@/pages/CompletionPage";
import ReviewPage from "@/pages/ReviewPage";
import PhaseCompletePage from "@/pages/PhaseCompletePage";
import ClosingCheckinPage from "@/pages/ClosingCheckinPage";
import WhatIsPage from "@/pages/WhatIsPage";
import AboutPage from "@/pages/AboutPage";
import FAQPage from "@/pages/FAQPage";
import BookPage from "@/pages/BookPage";
import AdminPage from "@/pages/AdminPage";
import { InstallBanner } from "@/components/InstallBanner";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

const MethodRedirect = () => {
  const navigate = useNavigate();
  useEffect(() => { navigate('/dashboard'); }, [navigate]);
  return null;
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Toaster position="top-center" richColors />
        <InstallBanner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/vad-ar-emotionell-frihet" element={<WhatIsPage />} />
            <Route path="/om-mig" element={<AboutPage />} />
            <Route path="/vanliga-fragor" element={<FAQPage />} />
            <Route path="/boken" element={<BookPage />} />
            <Route path="/logga-in" element={<LoginPage />} />
            <Route path="/registrera" element={<RegisterPage />} />
            <Route path="/betalning" element={
              <ProtectedRoute>
                <PaymentPage />
              </ProtectedRoute>
            } />
            <Route path="/betalning/klar" element={<PaymentSuccessPage />} />
            <Route path="/dashboard" element={
              <ProtectedRoute requirePayment>
                <DashboardPage />
              </ProtectedRoute>
            } />
            <Route path="/metoden" element={
              <ProtectedRoute requirePayment>
                <MethodRedirect />
              </ProtectedRoute>
            } />
            <Route path="/steg/:id" element={
              <ProtectedRoute requirePayment>
                <LayerDetailPage />
              </ProtectedRoute>
            } />
            <Route path="/min-resa" element={
              <ProtectedRoute requirePayment>
                <JournalPage />
              </ProtectedRoute>
            } />
            <Route path="/tester" element={
              <ProtectedRoute requirePayment>
                <SelfTestsPage />
              </ProtectedRoute>
            } />
            <Route path="/ovningar" element={
              <ProtectedRoute requirePayment>
                <ExercisesPage />
              </ProtectedRoute>
            } />
            <Route path="/dagbok" element={
              <ProtectedRoute requirePayment>
                <DiaryPage />
              </ProtectedRoute>
            } />
            <Route path="/citat" element={
              <ProtectedRoute requirePayment>
                <QuotesPage />
              </ProtectedRoute>
            } />
            <Route path="/progress" element={
              <ProtectedRoute requirePayment>
                <ProgressMapPage />
              </ProtectedRoute>
            } />
            <Route path="/avslutning" element={
              <ProtectedRoute requirePayment>
                <CompletionPage />
              </ProtectedRoute>
            } />
            <Route path="/fas-avslutning/:phase" element={
              <ProtectedRoute requirePayment>
                <PhaseCompletePage />
              </ProtectedRoute>
            } />
            <Route path="/avslutande-reflektion" element={
              <ProtectedRoute requirePayment>
                <ClosingCheckinPage />
              </ProtectedRoute>
            } />
            <Route path="/recensioner" element={<ReviewPage />} />
            <Route path="/admin" element={
              <ProtectedRoute requirePayment>
                <AdminPage />
              </ProtectedRoute>
            } />
          </Routes>
          <MobileBottomNav />
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
